import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
// import LiveStreamCard from './components/LiveStreamCard';
import NewsletterCard from './components/NewsletterCard';
import EventsCard from './components/EventsCard';
import ContactCard from './components/ContactCard';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import Notification from './components/Notification';
import { AuthProvider, useAuth } from './context/AuthContext';
import { useNotification, usePosts, /* useStreamSettings, */ useContactForm } from './hooks/useChurchData';

function AppContent() {
  const { isAuthenticated } = useAuth();
  // State management
  const [activeTab, setActiveTab] = useState('home');
  const [newPost, setNewPost] = useState({ title: '', content: '' });
  const [showEmbedInput, setShowEmbedInput] = useState(false);

  // Custom hooks for data management
  const { notification, showNotification } = useNotification();
  const { posts, loading: postsLoading, fetchPosts, addPost } = usePosts(showNotification);
  /*
  const {
    streamActive,
    facebookLiveUrl,
    setFacebookLiveUrl,
    fetchStreamSettings,
    fetchStreamStatus,
    updateStreamSettings,
    toggleStream,
    checkFacebookLive
  } = useStreamSettings(showNotification);
  */
  const {
    contactForm,
    setContactForm,
    loading: contactLoading,
    sendMessage
  } = useContactForm(showNotification);

  // Fetch data on component mount
  useEffect(() => {
    fetchPosts();
    // fetchStreamSettings();
  }, [fetchPosts /* , fetchStreamSettings */]);

  // Render content based on active tab
  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return (
          <div className="grid-layout">
            {/*
            <LiveStreamCard
              streamActive={streamActive}
              facebookLiveUrl={facebookLiveUrl}
              setFacebookLiveUrl={setFacebookLiveUrl}
              showEmbedInput={showEmbedInput}
              setShowEmbedInput={setShowEmbedInput}
              updateStreamSettings={updateStreamSettings}
              toggleStream={toggleStream}
              checkFacebookLive={checkFacebookLive}
              fetchStreamStatus={fetchStreamStatus}
              showNotification={showNotification}
            />
            */}
            <EventsCard />
          </div>
        );
      /*
      case 'stream':
        return (
          <LiveStreamCard
            streamActive={streamActive}
            facebookLiveUrl={facebookLiveUrl}
            setFacebookLiveUrl={setFacebookLiveUrl}
            showEmbedInput={showEmbedInput}
            setShowEmbedInput={setShowEmbedInput}
            updateStreamSettings={updateStreamSettings}
            toggleStream={toggleStream}
            checkFacebookLive={checkFacebookLive}
            fetchStreamStatus={fetchStreamStatus}
            showNotification={showNotification}
          />
        );
      */
      // case 'newsletter':
      //   return (
      //     <NewsletterCard
      //       posts={posts}
      //       newPost={newPost}
      //       setNewPost={setNewPost}
      //       loading={postsLoading}
      //       addPost={addPost}
      //       showNotification={showNotification}
      //     />
      //   );
      case 'events':
        return <EventsCard />;
      case 'contact':
        return (
          <div className="contact-layout">
            <ContactCard
              contactForm={contactForm}
              setContactForm={setContactForm}
              loading={contactLoading}
              sendMessage={sendMessage}
              showNotification={showNotification}
            />
          </div>
        );
      case 'admin':
        return isAuthenticated ? (
          <AdminDashboard
            posts={posts}
            newPost={newPost}
            setNewPost={setNewPost}
            loading={postsLoading}
            addPost={addPost}
            showNotification={showNotification}
          />
        ) : (
          <AdminLogin showNotification={showNotification} />
        );
      default:
        return (
          <div className="grid-layout">
            {/*
            <LiveStreamCard
              streamActive={streamActive}
              facebookLiveUrl={facebookLiveUrl}
              setFacebookLiveUrl={setFacebookLiveUrl}
              showEmbedInput={showEmbedInput}
              setShowEmbedInput={setShowEmbedInput}
              updateStreamSettings={updateStreamSettings}
              toggleStream={toggleStream}
              checkFacebookLive={checkFacebookLive}
              fetchStreamStatus={fetchStreamStatus}
              showNotification={showNotification}
            />
            */}
            <EventsCard />
          </div>
        );
    }
  };

  return (
    <div className="app-container">

      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <HeroSection />

      <main className="main-content">
        {renderContent()}
      </main>

      <footer className="footer">
        <div className="footer-container">
          <p className="footer-copyright">
            &copy; 2025 KOGK Christian Ministries. All rights reserved.
          </p>
          <p className="footer-tagline">
            Built with faith and love for our community
          </p>
        </div>
      </footer>

      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
